export interface JwtPayload {
  sub: number;
  name: string;
  exp?: number;
  groupId?: number;
  masterUser?: boolean;
  user?: { id: number };
  role?: number;
}

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

/**
 * True when the token is missing, unreadable, or past its `exp`.
 * A token without `exp` never expires.
 */
export function isTokenExpired(token: string | null | undefined, now = Date.now()): boolean {
  if (!token) return true;
  const payload = decodeJwt(token);
  if (!payload) return true;
  return payload.exp !== undefined && payload.exp * 1000 <= now;
}
